const ranges = {
  Simple: [49, 199],
  Medium: [199, 499],
  Complex: [499, 999],
};

export const calculateCost = (value: Json) => {
  const { complexity, exclusivity } = value;

  if (complexity === "Don't know") {
    return { isValid: false };
  }

  let min = 0;
  let max = 0;

  const range = ranges[complexity as keyof typeof ranges];

  if (range) {
    min = range[0];
    max = range[1];
  }

  if (exclusivity === 'Exclusive') {
    min += 200;
    max += 200;
  }

  return {
    isValid: true,
    min,
    max,
  };
};
